import React from 'react'
import { hot } from 'react-hot-loader/root'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { PolymorphicCopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { UserFeedback } from '@ta-interaktiv/react-user-feedback'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import Cover from '../cover'
import Scrollchor from 'react-scrollchor'
import Identificator from '../identificator/Identificator'
import Region from '../region'
import Barchart from '../barchart'
import Quizchart from '../quizchart'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import 'styles/App.css'

const landIcon = require('./img/icon-land.svg')
const stadtIcon = require('./img/icon-stadt.svg')

const ARTICLE_ID = '24778854'
const ADDITIONAL_SHARES = 406

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)

    this.state = {
      showQuarterList: false,
      readerIsCityCitizen: true,
      readerMadeHisChoice: false,
      chosenQuarter: '',
      showOverlay: false,
      dataSource: [
        { day: '02-11-1999', title: 'Kreis 1', count: 500 },
        { day: '02-12-2000', title: 'Kreis 2', count: 250 },
        { day: '02-13-2001', title: 'Kreis 3', count: 50 },
        { day: '02-14-2002', title: 'Kreis 4', count: 500 },
        { day: '02-15-2003', title: 'Kreis 5', count: 0 },
        { day: '02-16-2004', title: 'Kreis 6', count: 380 },
        { day: '02-17-2005', title: 'Kreis 7', count: 100 },
        { day: '02-18-2006', title: 'Kreis 8', count: 300 },
        { day: '02-16-2007', title: 'Kreis 6', count: 380 },
        { day: '02-17-2008', title: 'Kreis 7', count: 100 },
        { day: '02-18-2009', title: 'Kreis 8', count: 300 }
      ]
    }

    this.changeCitizenship = this.changeCitizenship.bind(this)
    this.changeChosenQuarter = this.changeChosenQuarter.bind(this)
  }

  changeChosenQuarter(newChoice) {
    this.setState({
      chosenQuarter: newChoice
    })
  }

  changeCitizenship(quarter, choice, choiceIsMade) {
    this.setState({
      chosenQuarter: quarter,
      readerIsCityCitizen: choice,
      readerMadeHisChoice: choiceIsMade,
      showQuarterList: false
    })
    if (quarter) {
      this.setState({
        chosenQuarterName: quarter.name,
        chosenCircleName: quarter.ortname,
        readerMadeHisChoice: true,
        readerIsCityCitizen: true
      })
    }
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          articleId='24778854'
          additionalShares={ADDITIONAL_SHARES}
          inverted
        />
        <header className='ui vertical fitted segment'>
          <Cover
            title='Landeier gegen Stadtkinder'
            subtitle='Der Stadt-Land-Graben im Datencheck'
          />
        </header>
        <figcaption className='ui container ta caption header-caption'>
          Fotos: Mario Nowak/EyeEm
        </figcaption>
        <main className='ui vertical segment'>
          <div className='ui text container'>
            <p className='ta lead'>
              Sind die Mütter bei der Niederkunft in der Stadt oder auf dem Land
              älter? Wo ist es gefährlicher? Wer wählt welche Partei? Schätzen
              Sie mit – und überdenken Sie Ihre Vorurteile.
            </p>
            <p className='ta author'>Von Mathias Lutz und Marc Brupbacher</p>
            <p>
              Der wahre Konflikt in der Schweiz sei nicht jener zwischen den
              Ethnien, Sprachregionen oder Konfessionen, sondern der zwischen
              Stadt und Land, heisst es. Wir haben anhand von 15 Datensätzen
              versucht herauszufinden, wie unterschiedlich die verschiedenen
              Siedlungstypen wirklich ticken.
            </p>

            <p>
              In der Schweiz leben 17 Prozent der Bevölkerung in den zehn
              grössten <span className='stadt box'>Städten</span> von Biel bis
              Zürich. Nur noch rund 15 Prozent wohnen «richtig» auf dem{' '}
              <span className='land box'>Land</span> – dies auf knapp 60 Prozent
              der Landesfläche in 768 Gemeinden. Alle anderen 68 Prozent leben
              in <span className='periurban box'>periurbanen</span> Gebieten, in{' '}
              <span className='städtisch box'>städtischen</span> Agglomerationen
              oder dörflichen Zentren (insgesamt 1477 Gemeinden) – also weder
              auf dem abgeschiedenen Land noch in einer Kernstadt.
            </p>
          </div>

          <div className='ui text container'>
            <div className='ui overview stackable grid' id='overview'>
              <h3>Wo die Schweizer Bevölkerung lebt</h3>
              <h4
                className='division countryside'
                style={{ backgroundImage: `url(${landIcon})` }}
              >
                Land
              </h4>
              <div className='eight column row doubling tablet hidden'>
                <div className='eight wide centered column'>
                  <div className='region'>
                    <Region reg='Land' pop='15.3' ar='58.7' />
                  </div>
                </div>
                <div className='eight wide centered column'>
                  <Region reg='Periurban' pop='21.9' ar='25.6' />
                </div>
                <h4
                  className='division city'
                  style={{ backgroundImage: `url(${stadtIcon})` }}
                >
                  Stadt
                </h4>
                <div className='eight wide centered column'>
                  <Region reg='Städtisch' pop='45.9' ar='14.6' />
                </div>
                <div className='eight wide centered column'>
                  <Region reg='Stadt' pop='17' ar='1.1' />
                </div>
              </div>
              <div className='eight column row tablet only'>
                <div className='eight wide centered column'>
                  <div className='region'>
                    <Region reg='Land' pop='15.3' ar='58.7' />
                  </div>
                </div>
                <div className='eight wide centered column'>
                  <Region reg='Periurban' pop='21.9' ar='25.6' />
                </div>
                <h4
                  className='division city'
                  style={{ backgroundImage: `url(${stadtIcon})` }}
                >
                  Stadt
                </h4>
                <div className='eight wide centered column'>
                  <Region reg='Städtisch' pop='45.9' ar='14.6' />
                </div>
                <div className='eight wide centered column'>
                  <Region reg='Stadt' pop='17' ar='1.1' />
                </div>
              </div>
              <div className='source'>
                Quelle: Bundesamt für Statistik, 2017
              </div>
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'startReading'
                })
              }
            }}
          />

          <div className='ui text container bar-chart'>
            <p>
              Mit statistischen Daten, welche wir vier Schweizer Siedlungstypen
              zuordnen, versuchen wir herauszufinden, in welchen Bereichen die
              Unterschiede zwischen urbanen und dörflichen Gebieten besonders
              gross sind (
              <Scrollchor to='#methodik'>
                <i className='icon external alternate' /> mehr zur Methodik
              </Scrollchor>
              ). Raten Sie mit, und überprüfen Sie Ihre Vorurteile!
            </p>
          </div>

          <div className='ui text container' style={{ position: 'relative' }}>
            <Barchart
              title='Wo die Schweiz wächst'
              subtitle='Veränderung der ständigen Wohnbevölkerung, 2010–2016'
              l='5.6'
              p='8.1'
              s='7.0'
              st='6.7'
              ch='7.0'
              suffix='%'
              source='BFS – Bilanz der ständigen Wohnbevölkerung'
            >
              <p>
                Von 2010 bis 2016 wuchs die Schweizer Bevölkerung um sieben
                Prozent. Ländliche Regionen wuchsen nur unterdurchschnittlich –
                viele schrumpften gar, vor allem in den Bergregionen. Der grosse
                Boom der Städte ist aber ebenfalls vorbei. Am stärksten wuchsen
                periurbane Agglomerationsgemeinden – rund 70 Prozent der
                Schweizer Bevölkerung leben mittlerweile dort. Prognose für die
                Zukunft: Die Randregionen werden sich weiter entvölkern, es ist
                eine unumkehrbare Entwicklung. Die Wanderungsströme werden in
                jenen Kantonen positiv bleiben, die im Einflussbereich der
                grossen Städte liegen.
              </p>
            </Barchart>

            <Quizchart
              qId='quiz-0'
              title='Wo mehr Wohnungen gebaut werden'
              question='Wo werden mehr Wohnungen gebaut?'
              subtitle='Neu erstellte Wohnungen pro 1000 Einwohner, 2015'
              l='7.55'
              p='6.88'
              s='6.25'
              st='5.04'
              ch='6.38'
              suffix=''
              source='BFS – Gebäude- und Wohnungsstatistik'
              articleId='24778854'
            >
              <p>
                Überraschenderweise werden auf dem Land mehr Wohnungen pro Kopf
                gebaut als in der Stadt. Wie die «Wo die Schweiz wächst»-Grafik
                zeigt, müsste es doch aber genau umgekehrt sein. Viele Wohnungen
                sind in den letzten Jahren also nicht dort entstanden, wo eine
                Nachfrage besteht. Weil es in grossen Städten wie Zürich an
                Boden fehlt und die Bewilligungsverfahren länger dauern, weichen
                Grossinvestoren in ländlichere Regionen aus. Dort bleiben dann
                die Wohnungen allerdings oft leer. Über diese Fehlentwicklung
                haben wir erst kürzlich im Artikel{' '}
                <a href='https://www.tagesanzeiger.ch/30482348' target='_blank'>
                  «Voll verplant»
                </a>{' '}
                berichtet.
              </p>
            </Quizchart>

            <Quizchart
              qId='quiz-1'
              title='Wo mehr Babys geboren werden'
              question='Wo werden mehr Babys geboren?'
              subtitle='Anzahl Lebendgeburten pro 1000 Einwohner, 2016'
              l='9.7'
              p='9.9'
              s='10.4'
              st='12.1'
              ch='10.5'
              suffix=''
              source='BFS – Statistik der natürlichen Bevölkerungsbewegung'
              articleId='24778854'
            >
              <p>
                Es gibt einen kleinen Babyboom in Schweizer Städten. Junge Paare
                können sich ein Familienleben heute auch in der Stadt vorstellen
                und ziehen nicht zwingend in Vororte. Zudem haben ausländische
                Frauen tendenziell mehr Kinder als Schweizer Frauen, und die
                leben eher in Städten. Städtische Gemeinden haben zwar nach wie
                vor eine niedrigere Geburtenziffer als ländliche Gebiete, das
                heisst weniger Geburten pro 1000 Frauen im gebärfähigen Alter.
                Dafür liegt die rohe Geburtenziffer höher, die auch oben
                visualisiert ist. Es gibt also vergleichsweise viele Geburten,
                wenn man sie an der Gesamtbevölkerung misst. Der Grund dafür ist
                der überdurchschnittlich hohe Anteil von Frauen im Alter von 25
                bis 39 in Schweizer Städten.
              </p>
            </Quizchart>

            <Quizchart
              qId='quiz-2'
              title='Wo Mütter bei der Geburt am ältesten sind'
              question='Wo sind die Mütter bei der Geburt älter?'
              subtitle='Anteil der Mütter im Alter >35 an allen Lebendgeburten, 2016'
              l='25.3'
              p='31.1'
              s='30.9'
              st='38.6'
              ch='31.7'
              suffix='%'
              source='BFS – Statistik der natürlichen Bevölkerungsbewegung'
              articleId='24778854'
            >
              <p>
                Das Durchschnittsalter von Müttern bei der Geburt liegt in der
                Schweiz inzwischen bei knapp 32 Jahren – 1971 lag es noch bei
                27,7 Jahren. Nur in Italien und in Spanien gebären in Europa die
                Frauen in ähnlich hohem Alter. In Schweizer Städten sind
                inzwischen knapp 40 Prozent der Frauen bei der Geburt mindestens
                35 Jahre alt – unabhängig davon, ob es das erste, zweite oder
                dritte Kind ist. Auf dem Land ist jede vierte Frau beim
                Zeitpunkt der Geburt über 35. Längere Ausbildungszeiten, der
                spätere Eintritt ins Berufsleben, Veränderungen der Lebens- und
                Verhaltensweisen erklären den Anstieg.
              </p>
            </Quizchart>

            <Barchart
              title='Wer dichter wohnt'
              subtitle='Anzahl Einwohner pro km², 2016'
              l='54.8'
              p='179.7'
              s='663.1'
              st='3144.8'
              ch='210.6'
              suffix=''
              source='BFS – Bilanz der ständigen Wohnbevölkerung'
            >
              <p>
                Die Unterschiede sind erwartbar gewaltig. Die grösste
                Bevölkerungsdichte in der Schweiz weist die Stadt Genf auf.
                Unter den Top 10 sind mit Basel, Rorschach und Zürich nur drei
                Städte aus der Deutschschweiz vertreten, die restlichen Städte
                liegen in der Romandie.
              </p>
            </Barchart>

            <Barchart
              title='Wo mehr Ausländer wohnen'
              subtitle='Anteil Ausländer an der ständigen Wohnbevölkerung, 2016'
              l='17.0'
              p='17.2'
              s='27.7'
              st='34.6'
              ch='25'
              suffix='%'
              source='BFS – Bilanz der ständigen Wohnbevölkerung'
            >
              <p>
                In der Schweiz leben etwas mehr als zwei Millionen Ausländer.
                Der Ausländeranteil im Siedlungstyp Stadt ist exakt doppelt so
                gross wie auf dem Land. Die Gemeinde mit dem grössten
                Ausländeranteil in der Schweiz ist Kreuzlingen TG: Hier haben
                54,6 Prozent keinen Schweizer Pass, die Hälfte davon sind
                Deutsche. Darauf folgen Renens VD (51,1 Prozent) und
                Spreitenbach AG (50,4 Prozent). Die Stadt Genf verfügt mit 47,8
                Prozent Ausländern den höchsten Anteil unter den Grossstädten.
              </p>
            </Barchart>

            <Quizchart
              qId='quiz-3'
              title='Wo mehr 20- bis 39-Jährige leben'
              question='Wo leben mehr Junge (20- bis 39-Jährige)?'
              subtitle='Anteil der 20–39-jährigen an der ständigen Wohnbevölkerung, 2016'
              l='24.8'
              p='23.7'
              s='26.4'
              st='33.1'
              ch='26.7'
              suffix='%'
              source='BFS – Statistik der Bevölkerung und der Haushalte'
              articleId='24778854'
            >
              <p>
                In den grossen Städten sind ein Drittel der Einwohner zwischen
                20 und 39 Jahre alt, es ist die grösste Altersgruppe in der
                Stadt. Auf dem Land beträgt dieser Anteil lediglich 24,8
                Prozent. In periurbanen und ländlichen Gebieten leben dafür
                deutlich mehr 40- bis 79-Jährige als in der Stadt. Allerdings:
                Kinder und Jugendliche (0–19) gibt es anteilsmässig nach wie vor
                mehr auf dem Land (20,8 Prozent) als in der Stadt (17,5
                Prozent).
              </p>
            </Quizchart>

            <Quizchart
              qId='quiz-4'
              title='Wo mehr geheiratet wird'
              question='Wo wird mehr geheiratet?'
              subtitle='Anzahl Heiraten pro 1000 Einwohner, 2016'
              l='4.4'
              p='4.5'
              s='5.0'
              st='6.0'
              ch='5.0'
              suffix='%'
              source='BFS – Statistik der natürlichen Bevölkerungsbewegung'
              articleId='24778854'
            >
              <p>
                Es ist schwierig zu sagen, weshalb die Heiratsziffer abnimmt von
                städtisch zu ländlich. Mögliche Gründe: In den Städten leben
                mehr Ausländer, und entgegen der verbreiteten Heiratsmüdigkeit
                steigt die Zahl der gemischt-nationalen Ehen in der Schweiz
                stetig an. Zudem leben in den Städten eher jüngere Personen im
                passenden Alter fürs Standesamt.
              </p>
            </Quizchart>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '50ContentRead'
                  })
                }
              }}
            />

            <div className='bar-chart custom'>
              <h3>Wer welche Partei wählt</h3>
              <h5>Parteistärken bei Nationalratswahlen, 2015</h5>
              <img
                src={require('./img/parteistaerken.svg')}
                alt='Quantum Global-Hauptsitz, Zug'
                className='ui fluid image'
              />
              <div className='source'>
                Quelle: BFS–Statistik der Wahlen und Abstimmungen
              </div>
              <p>
                Der Stadt-Land-Graben ist in der Politik Realität: Die Städte
                stehen politisch links, während das Land konservativ eingestellt
                ist. Dies, obwohl die Mobilität zwischen ländlichen und
                städtischen Gebieten stark zugenommen hat. SVP und CVP sind die
                ländlichsten unter den Schweizer Parteien. SP und Grüne haben
                ihre Basis in städtischen Gemeinden. Die FDP ist in der
                Agglomeration am stärksten. Diese Verteilung prägt die Schweizer
                Politlandschaft seit langem.
              </p>
            </div>

            <Quizchart
              qId='quiz-5'
              title='Wo die Wahlbeteiligung höher ist'
              question='Wo ist die Wahlbeteiligung höher?'
              subtitle='Wahlbeteiligung bei Nationalratswahlen, 2015'
              l='50.1'
              p='50.3'
              s='48.1'
              st='48.2'
              ch='48.5'
              suffix='%'
              source='BFS – Statistik der Wahlen und Abstimmungen'
              articleId='24778854'
            />

            <Barchart
              title='Wo es mehr Jobs gibt'
              subtitle='Vollzeitjobs pro 1000 Einwohner, 2015'
              l='378'
              p='288'
              s='487'
              st='816'
              ch='483'
              suffix=''
              source='BFS – Statistik der Unternehmensstruktur'
            >
              <p>
                Wer einen Job will, kommt an der Stadt nicht vorbei: Rund 53
                Prozent aller Arbeitsstätten und 76 Prozent aller
                Grossunternehmen (+250 Beschäftigte) befinden sich in
                städtischen Gebieten.
              </p>
            </Barchart>

            <Barchart
              title='Wo es gefährlicher ist'
              subtitle='Straftaten gemäss Strafgesetzbuch pro 1000 Einwohner, 2014'
              l='37.4'
              p='36.9'
              s='60.4'
              st='121.1'
              ch='64.6'
              suffix=''
              source='BFS – Polizeiliche Kriminalstatistik'
            >
              <p>
                Es ist kein Klischee: In den Städten werden deutlich mehr
                Straftaten verübt als auf dem Land. Die kriminellsten Städte,
                nur auf Gewaltdelikte bezogen, waren 2017: Basel (13,7 Delikte
                pro 1000 Einwohner), La Chaux-de-Fonds (11,6), Lausanne (11,4),
                Biel (11,2), Freiburg (10,6).
              </p>
            </Barchart>

            <Barchart
              title='Wo mehr Sozialfälle wohnen'
              subtitle='Sozialhilfequote, 2016'
              l='2.1'
              p='1.9'
              s='3.5'
              st='5.8'
              ch='3.2'
              suffix='%'
              source='BFS – Statistik über die Sozialhilfeempfängerinnen und -empfänger in der Schweiz'
            >
              <p>
                2016 gab es in der Schweiz 273’273 unterstützungsbedürftige
                Personen, davon lebten 69,4 Prozent in urbanen Räumen. In den
                Städten La Chaux-de-Fonds (11,9 Prozent), Biel (11,8 Prozent)
                und Neuenburg (9,6 Prozent) leben anteilsmässig die meisten
                Sozialhilfebezüger. Generell fällt auf, dass in der Romandie
                mehr Personen Unterstützung benötigen als in der Deutschschweiz.
              </p>
            </Barchart>

            <Quizchart
              qId='quiz-6'
              title='Wo die Einwohner mehr Autos besitzen'
              question='Wo besitzen die Einwohner mehr Autos?'
              subtitle='Personenwagen pro 1000 Einwohner, 2018'
              l='657.5'
              p='655.5'
              s='579.1'
              st='401.4'
              ch='579.4'
              suffix=''
              source='Bundesamt für Strassen Astra'
              articleId='24778854'
            >
              <p>
                In der Schweiz sind über 4,5 Millionen Autos und 720’000
                Motorräder registriert. Den tiefsten Anteil Personenwagen pro
                Person weisen die grossen Städte Basel (334 Autos pro 1000
                Einwohner), Zürich (347), Lausanne (362) und Genf (368) auf. Die
                höheren Werte in kleineren Städten und auf dem Land hängen mit
                der schlechteren Erschliessung durch den öffentlichen Verkehr
                und dem Umstand zusammen, dass in diesen Gemeinden der
                Arbeitsort oft nicht mit dem Wohnort zusammenfällt. Seit 2007
                nahm der Motorisierungsgrad in den grössten Städten der Schweiz
                um gut 12 Prozent ab. 2007 kamen dort auf einen Einwohner noch
                0,42 Personenwagen, 2016 nur noch 0,36. In allen anderen
                Gemeindegrössenklassen ist der Motorisierungsgrad seit 2007
                jedoch gestiegen.
              </p>
            </Quizchart>

            <Quizchart
              qId='quiz-7'
              title='Wo die Einwohner mehr Elektroautos besitzen'
              question='Wo besitzen die Einwohner mehr Elektroautos?'
              subtitle='Elektrische Personenwagen pro 1000 Einwohner, 2018'
              l='2.0'
              p='2.8'
              s='2.1'
              st='1.7'
              ch='2.2'
              suffix=''
              source='Bundesamt für Strassen Astra'
              articleId='24778854'
            />

            <Quizchart
              qId='quiz-8'
              title='Wo es mehr Arztpraxen gibt '
              question='Wo gibt es mehr Arztpraxen pro Kopf?'
              subtitle='Arztpraxen pro 1000 Einwohner, 2015'
              l='1.02'
              p='0.84'
              s='2.43'
              st='5.89'
              ch='2.31'
              suffix=''
              source='BFS - Dienstleistungen für die Bevölkerung'
              articleId='24778854'
            />

            <Quizchart
              qId='quiz-9'
              title='Wo es mehr Restaurants gibt'
              question='Wo gibt es mehr Restaurants pro Kopf?'
              subtitle='Restaurants, Cafés pro 1000 Einwohner, 2015'
              l='4.50'
              p='2.26'
              s='2.73'
              st='4.07'
              ch='3.13'
              suffix=''
              source='BFS - Dienstleistungen für die Bevölkerung'
              articleId='24778854'
            />

            <Quizchart
              qId='quiz-10'
              title='Wo es mehr Schulen gibt'
              question='Wo gibt es mehr Schulen pro Kopf?'
              subtitle='Obligatorische Schulen (Primarstufe + Sekundarstufe I) pro 1000 Einwohner, 2015'
              l='1.72'
              p='1.58'
              s='1.19'
              st='1.14'
              ch='1.34'
              suffix=''
              source='BFS - Dienstleistungen für die Bevölkerung'
              articleId='24778854'
            />
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'pageBottom'
                })
              }
            }}
          />

          <div className='ui text container'>
            <p>
              Unabhängig der teilweise grossen statistischen Kluft zwischen Dorf
              und Stadt sind die meisten Schweizer sehr zufrieden mit ihrem
              Leben - egal, wo sie leben. Auf einer Skala von 0 (gar nicht
              zufrieden) bis 10 (vollumfänglich zufrieden) liegt die
              durchschnittliche Bewertung bei einer 8. Das zeigt eine Umfrage
              des Bundesamts für Statistik. Auf dem Land zeigen sich die
              Befragten leicht zufriedener (8,1) als in den Städten (7,7). Die
              Unterschiede sind klein und scheinen wenig signifikant zu sein.
              Bisher konnte die Glücksforschung nicht feststellen, dass Menschen
              auf dem Land zufriedener sind als in der Stadt – eher das
              Gegenteil. Sicher ist nur, dass Pendeln unglücklich macht.
            </p>
          </div>
        </main>

        <Footer
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
          hidePortfolioTeaser
          questions={[
            'Wie informativ war der Beitrag?',
            'Funktionierte die technische Umsetzung?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Konzept, Programmierung',
              'Marc Brupbacher und Mathias Lutz, Interaktiv-Team'
            ],
            [
              'Inspiration',
              '<a href="https://www.zeit.de/feature/deutsche-bevoelkerung-stadt-land-unterschiede-vorurteile" target="_blank">Stadt, Land, Vorurteil, ZEIT ONLINE</a>'
            ]
          ]}
        >
          <main className='ui vertical fitted attached segment' id='methodik'>
            <div className='ui text container' style={{ position: 'relative' }}>
              <h3>Methodik</h3>
              <p>
                Weil die Grenzen zwischen Stadt und Land unscharf sind, arbeitet
                das Bundesamt für Statistik mit einem komplexen Modell, das die
                Schweizer Gemeinden unter anderem in 9 Typen unterteilt
                (Gemeindetypologie und Stadt/Land-Typologie 2012). Dabei spielen
                Dichte-, Grössen- und Erreichbarkeitskriterien eine Rolle (
                <a href='https://www.bfs.admin.ch/bfs/de/home/statistiken/querschnittsthemen/raeumliche-analysen/raeumliche-gliederungen/raeumliche-typologien.assetdetail.2543323.html'>
                  <i className='icon external alternate' />
                  Räumliche Typologien des Bundesamtes für Statistik
                </a>
                ).
              </p>

              <p>
                Unsere Stadt/Land-Typologie wiederum ist von dieser
                Gemeindetypologie mit 9 Kategorien abgeleitet. Neben einer{' '}
                <span className='städtisch box'>
                  <Scrollchor to='#overview'>städtischen</Scrollchor>
                </span>{' '}
                und einer{' '}
                <span className='land box'>
                  <Scrollchor to='#overview'>ländlichen</Scrollchor>
                </span>{' '}
                Kategorie haben wir auch einen Typ{' '}
                <span className='periurban box'>
                  <Scrollchor to='#overview'>periurban</Scrollchor>
                </span>
                , der sowohl städtische wie auch ländliche Merkmale aufweist,
                bzw. ländliche Gebiete mit kurzen Fahrzeiten zum Zentrum von
                Agglomerationen beinhaltet. Dieser Ansatz erlaubt es, die
                heutigen Gegebenheiten auf angemessene Art und Weise abzubilden.
                Als vierte Kategorie haben wir in Absprache mit dem BFS die neu
                geschaffene Kategorie{' '}
                <span className='stadt box'>
                  <Scrollchor to='#overview'>Stadt</Scrollchor>
                </span>{' '}
                hinzugefügt, welche die zehn grössten Städte der Schweiz
                umfasst.
              </p>

              <div className='ui text container'>
                <Identificator
                  readerIsCityCitizen={this.state.readerIsCityCitizen}
                  readerMadeHisChoice={this.state.readerMadeHisChoice}
                  clickHandler={this.changeCitizenship}
                  changeChosenQuarter={this.changeChosenQuarter}
                  showQuarterList={this.state.showQuarterList}
                />
              </div>

              <p>
                Die Datensätze wurden für die Visualisierung normalisiert, das
                heisst in Relation zur Einwohnerzahl der jeweiligen
                Siedlungstyp-Kategorie gesetzt. Für die Darstellung der
                Sozialhilfequote wurden beispielsweise die absoluten Zahlen der
                Sozialhilfebeziehenden jeder Gemeinde pro Kategorie addiert und
                danach der prozentuale Anteil an der ständigen Wohnbevölkerung
                2016 berechnet.
              </p>
            </div>
          </main>
        </Footer>
      </div>
    )
  }
}

export default hot('AppComponent')
